import Header from "./Home/Header";
import Footer from "./Footer/Footer";
import "./css/flaticon.min.css";
import "./css/fontawesome-5.14.0.min.css";
import "./Main.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import {
  EMAILJS_SERVICE_ID,
  EMAILJS_CONTACT_TEMPLATE_ID,
  EMAILJS_AUTOREPLY_TEMPLATE_ID,
  EMAILJS_PUBLIC_KEY,
} from "./emailjsConfig";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { FaPhoneVolume } from "react-icons/fa6";
import CircularProgress from "@mui/material/CircularProgress";

import {
  IoLogoFacebook,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoMail,
} from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { FormControl, MenuItem, Select, styled } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const BorderlessSelect = styled(Select)({
  "&.MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
      borderBottom: "1px solid #8D8D8D",
      borderRadius: "0px",
    },
  },
});

const Contact = () => {
  const [data, setData] = useState<any>({
    name: "",
    mail: "",
    phonenumber: "",
    subject: "",
    message: "",
    address: "",
  });

  const [isLoader, setIsloader] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const handleContact = async (e: any) => {
    e.preventDefault();
    try {
      setIsloader(true);
      const params = {
        name: data.name,
        mail: data.mail,
        from_email: data.mail,
        phonenumber: data.phonenumber,
        subject: data.subject,
        address: data.address,
        message: data.message,
      };
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_CONTACT_TEMPLATE_ID,
        params,
        { publicKey: EMAILJS_PUBLIC_KEY }
      );
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_AUTOREPLY_TEMPLATE_ID,
        params,
        { publicKey: EMAILJS_PUBLIC_KEY }
      );
      setOpen(true);
      setData({
        name: "",
        mail: "",
        phonenumber: "",
        subject: "",
        message: "",
        address: "",
      });
      setIsloader(false);
    } catch (err: any) {
      setIsloader(false);
      console.log(err.message);
      alert("Got internal error");
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us</title>
        <meta
          name="description"
          content="Connect with us today! Our team is ready to assist you. Reach out for inquiries, collaborations, or just to say hello. Let's start a conversation!"
        />
      </Helmet>
      <Header />
      <section
        className="page-banner-area   pt-130 rpt-150 pb-130 rpb-100 rel z-1 bgc-lighter text-center"
        style={{ backgroundColor: "#fbfbfb" }}
      >
        <div className="container">
          <div>
            <h1 className="contact-head">Contact Us</h1>
            <p className="contact-subhead">
              Any question or remarks? Just write us a message!
            </p>
            <div className="row">
              <div
                className="col-lg-10 col-md-12 col-sm-12 col-12 py-15"
                style={{ background: "#fff", borderRadius: "10px" }}
              >
                <div className="row text-start">
                  <div className="col-lg-5 col-sm-12 col-md-12 col-12 p-0">
                    <div
                      style={{
                        background: "#011C2B",
                        borderRadius: "10px",
                        overflow: "hidden",
                      }}
                      className="py-50 px-4 position-relative"
                    >
                      <div className="contact-right">
                        <h6>Contact Information</h6>
                        <p>
                          Let's Start New Project or work Together! Contact With
                          us Now.
                        </p>
                        <div className="contact-padd">
                          <div className="d-flex">
                            <div className="me-2">
                              <FaPhoneVolume style={{ color: "#fff" }} />
                            </div>
                            <div>
                              <span>+91 9799184337 / +91 89257 90019</span>
                              <br />
                              <span>/ +91 86086 17609</span>
                            </div>
                          </div>
                          <div className="d-flex py-20">
                            <div className="me-2">
                              <IoMail style={{ color: "#fff" }} />
                            </div>
                            <div>
                              <span>operations.tth@thetechhorse.com</span>
                            </div>
                          </div>
                          <div className="d-flex">
                            <div className="me-2">
                              <FaLocationDot style={{ color: "#fff" }} />
                            </div>
                            <div>
                              <span>Location</span>
                              <br />
                              <span>
                                Royapettah, Chennai, Tamil Nadu 600014
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="soc-ul">
                          <ul>
                            <li>
                              <a  rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/people/The-Tech-Horse-Technologies/61550827268393/">
                              <IoLogoFacebook
                                style={{ color: "#F6AF03", fontSize: "20px" }}
                              /></a>
                            </li>
                            <li className="mx-3">
                              <a  rel="noopener noreferrer" href="https://www.instagram.com/tthtechnologies/" target="_blank">
                              <IoLogoInstagram
                                style={{ color: "#F6AF03", fontSize: "20px" }}
                              /></a>
                            </li>
                            <li>
                              <a  rel="noopener noreferrer" href="https://www.linkedin.com/in/the-tech-horse-946a12299/" target="_blank">
                              <IoLogoLinkedin
                                style={{ color: "#F6AF03", fontSize: "20px" }}
                              /></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="big-circle"></div>
                      <div className="small-circle"></div>
                    </div>
                  </div>
                  <div className="col-lg-7 col-sm-12 col-md-12 col-12 py-15">
                    <div className="contact-right">
                      <div className="row py-4">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 py-2">
                          <div>
                            <label>
                              Full Name <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              value={data.name}
                              onChange={(e) =>
                                setData({ ...data, name: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12  py-2">
                          <div>
                            <label>Address</label>
                            <input
                              value={data.address}
                              onChange={(e) =>
                                setData({ ...data, address: e.target.value })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12  pb-2">
                          <div>
                            <label>
                              Email <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              value={data.mail}
                              onChange={(e) =>
                                setData({ ...data, mail: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12  pb-2">
                          <div>
                            <label>
                              Phone Number{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              value={data.phonenumber}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  phonenumber: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row py-4">
                        <div className="col-lg-12  pb-2">
                          <label>
                            Select Subject ?{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <FormControl fullWidth>
                            <BorderlessSelect
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={data.subject}
                              onChange={(e) =>
                                setData({ ...data, subject: e.target.value })
                              }
                            >
                              <MenuItem value={"Product Enquiry"}>
                                Product Enquiry
                              </MenuItem>
                              <MenuItem value={"General Inquiry"}>
                                General Inquiry
                              </MenuItem>
                              <MenuItem value={"Website services"}>
                                Website services
                              </MenuItem>
                              <MenuItem value={"Mobile app services"}>
                                Mobile app services
                              </MenuItem>
                            </BorderlessSelect>
                          </FormControl>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12   py-2">
                          <div>
                            <label>
                              Message <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              placeholder="Write your message.."
                              value={data.message}
                              onChange={(e) =>
                                setData({ ...data, message: e.target.value })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="text-center py-4">
                        <Button
                          className="mesg-btn"
                          disabled={isLoader}
                          onClick={handleContact}
                        >
                          {" "}
                          {isLoader ? (
                            <CircularProgress
                              size={24}
                              style={{ color: "white", position: "absolute" }}
                            />
                          ) : (
                            "Send Message"
                          )}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       <section className="our-location-address-area rel z-1">
        <div className="container">
          <div className="row medium-gap justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="location-address-item wow fadeInUp delay-0-2s">
                <div className="top-part">
                  <div>
                  <img
                    src="/assets/us.webp"
                    alt="Location"
                    loading="lazy"
                    style={{height:"200px",width:"100%",objectFit:"cover"}}
                  />
                  </div>
                  <h5>USA</h5>
                </div>
                <div className="bottom-part">
                  <ul>
                    <li>
                      <i
                        className="fal fa-map-marker-alt"
                        style={{ color: "#f4c939" }}
                      />
                     Boca Raton, Fl 33428
                    </li>
                    {/* <li>
                      <i className="far fa-envelope-open-text" style={{color:"#f4c939"}}/>{" "}
                      support@gmail.com
                    </li> */}
                    <li>
                      <i
                        className="far fa-phone"
                        style={{ color: "#f4c939" }}
                      />{" "}
                      +1 (256)226-2281
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="location-address-item wow fadeInUp delay-0-4s">
                <div className="top-part">
                  <img
                    src="/assets/aus.webp"
                    alt="Location"
                    loading="lazy"
                      style={{height:"200px",width:"100%",objectFit:"cover"}}
                  />
                  <h5>Australia</h5>
                </div>
                <div className="bottom-part">
                  <ul>
                    <li>
                      <i
                        className="fal fa-map-marker-alt"
                        style={{ color: "#f4c939" }}
                      />{" "}
                     Melbourne Vic 3016

                    </li>
                    {/* <li>
                      <i className="far fa-envelope-open-text" style={{color:"#f4c939"}}/>{" "}
                      support@gmail.com
                    </li> */}
                    <li>
                      <i
                        className="far fa-phone"
                        style={{ color: "#f4c939" }}
                      />{" "}
                      +61 416795191
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="location-address-item wow fadeInUp delay-0-6s">
                <div className="top-part">
                  <img
                    src="/assets/dubai.webp"
                    alt="Location"
                    loading="lazy"
                      style={{height:"200px",width:"100%",objectFit:"cover"}}
                  />
                  <h5>Dubai</h5>
                </div>
                <div className="bottom-part">
                  <ul>
                    <li>
                      <i
                        className="fal fa-map-marker-alt"
                        style={{ color: "#f4c939" }}
                      />
                     Al Rashidiya 3 7613
                    </li>
                    {/* <li>
                      <i className="far fa-envelope-open-text" style={{color:"#f4c939"}}/>{" "}
                      support@gmail.com
                    </li> */}
                    <li>
                      <i
                        className="far fa-phone"
                        style={{ color: "#f4c939" }}
                      />{" "}
                      +971 529817609
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Our Location Address Area end */}
      {/* Location Map Area Start */}
      <div className="contact-page-map wow fadeInUp delay-0-2s">
        <div className="our-location">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d124375.27555406593!2d80.18136474503294!3d13.053018362998195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x693392f67a03638b%3A0x13d92b9fcbe060a3!2s292%2C%20Royapettah%20High%20Rd%2C%20Ganapathy%20Colony%2C%20Royapettah%2C%20Chennai%2C%20Tamil%20Nadu%20600014!3m2!1d13.0530314!2d80.2637666!5e0!3m2!1sen!2sin!4v1714992229944!5m2!1sen!2sin"
            style={{ border: 0, width: "100%" }}
            allowFullScreen
            loading="lazy"
            title="map"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      {/* Location Map Area End */}
      <Footer />

      {/* SuccessMessage */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="text-center">
            <img
              className="img-fluid"
              style={{ width: "100px" }}
              src="/assets/certificate.gif"
              loading="lazy"
              alt="cert"
            />
          </div>
          <h3 className="text-center mb-0">
            Your message has been sent successfully.
          </h3>
          <h3 className="text-center mt-0">We will reach you out soon...</h3>
          <div className="text-end">
            <Link to="/">
              <Button className="continue">Continue ..</Button>
            </Link>
          </div>
        </Box>
      </Modal>
    </>
  );
};
export default Contact;
